<template>
<div class="about">
<navbar></navbar>
    <div class="hero">
        <div class="container">
          <div class="row h-100 justify-content-center">
            <div class="col-md-6 right-border">
              <div class="hero-content">
                <h1 class="hero-title"> <i class="fa fa-info-circle symbols"></i>
                  Informazioni utili
                </h1>
                <p>
                  Attenzione leggere attentamente le condizioni prima di effettuare l'ordine. <br> Il servizio è attivo a :<br>
                  CANNIGIONE, PALAU, ARZACHENA, OLBIA, ABBIADORI, BAJA SARDINIA, LA MADDALENA, PORTO SAN PAOLO, GOLFO ARANCI, SAN TEODORO, BUDONI e S.TERESA<br>
                </p>
                <p><strong>Modalità d'ordine:</strong> crea la tua lista della spesa come se stessi scrivendo su un foglio, indica i prodotti e le quantità desiderate e conferma l'ordine.
                </p>
                <p><strong>Consegna:</strong> garantita in 24 ore!</p>
                <p><strong>Modalità di pagamento:</strong> alla consegna della spesa tramite carte, bancomat e contanti. Utilizziamo POS contactless per una maggiore sicurezza.</p>
                <p>Per informazioni contattare il servizio clienti al seguente recapito: <a href="mailto:spesaonline@dettorimarket.it>">spesaonline@dettorimarket.it</a></p>

              </div>
            </div>
          
            <div class="col-md-6 ">
              <div class="hero-content">
                <h1 class="hero-title"> <i class="fa fa-shipping-fast symbols"></i>
                  Consegne
                </h1>
                <p>
                Le consegne nei comuni di SANT'ANTONIO e LUOGOSANTO avvengono nei seguenti giorni:
                <ul>
                  <li>Lunedì</li>
                  <li>Mercoledì</li>
                  <li>Venerdì</li></ul>
                </p>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "About",
  props: {
    msg: String
  },
  methods: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .hero{
    padding-top: 7rem;
    width: 100%;
    height: 500px;
    text-align: left;
  }
.symbols {
  color: orange !important;
}
.right-border {
  border-color:orange;
  border-right-style: solid;
  border-right-width: thin;
}
</style>
